import { getProjectWallsObjects } from "@/speckleUtils";
import { ref } from "vue";

function getNestedValue(obj, path) {
  return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

export function useWallSelection() {
  const items = ref([]);
  const selected = ref(null);

  const loadWalls = async (projectId, objectRef, lang = "en") => {
    let wallData = [];
    let limit = 200;
    let cursor = null;
    let response = null;

    do {
      response = await getProjectWallsObjects(projectId, objectRef, lang, limit, cursor);
      wallData = wallData.concat(response.data.project.object.children.objects);
      cursor = response.data.project.object.children.cursor;
    } while (cursor);

    const groupedWallData = wallData.reduce((acc, item) => {
      const type = item.data.type;
      if (!acc[type]) {
        acc[type] = { type, ids: [], parameters: [] };
      }

      acc[type].ids.push(item.data.id);

      const paramsRoot =
        item.data.properties && item.data.properties.Parameters
          ? item.data.properties.Parameters
          : {};

      const areaPath =
        lang === "fr"
          ? ["Instance Parameters", "Cotes", "Surface", "value"]
          : ["Instance Parameters", "Dimensions", "Volume", "value"];

      const lengthPath =
        lang === "fr"
          ? ["Instance Parameters", "Cotes", "Longueur", "value"]
          : ["Instance Parameters", "Dimensions", "Length", "value"];

      const widthPath =
        lang === "fr"
          ? ["Type Parameters", "Construction", "Largeur", "value"]
          : ["Type Parameters", "Construction", "Width", "value"];

      const typeCommentsPath =
        lang === "fr"
          ? ["Type Parameters", "Données d'identification", "Commentaires du type", "value"]
          : ["Type Parameters", "Identity Data", "Type Comments", "value"];

      acc[type].parameters.push({
        area: getNestedValue(paramsRoot, areaPath) ?? null,
        curveLength: getNestedValue(paramsRoot, lengthPath) ?? null,
        width: getNestedValue(paramsRoot, widthPath) ?? null,
        typeComments: getNestedValue(paramsRoot, typeCommentsPath) ?? null,
      });

      return acc;
    }, {});

    items.value = Object.values(groupedWallData);
  };

  const autoSelectWallTypes = () => {
    selected.value = items.value.filter((item) =>
      item.parameters?.some(
        (p) => typeof p.typeComments === "string" && p.typeComments.trim().toUpperCase() === "QWEB"
      )
    );
  };

  const selectWallsByTypes = (selectedTypes = []) => {
    selected.value = items.value.filter((item) =>
      selectedTypes.some((typeObj) => typeObj.wallType === item.type)
    );
  };

  return { items, selected, loadWalls, autoSelectWallTypes, selectWallsByTypes };
}
